<p-button (onClick)="menu.toggle($event)"
  severity="secondary"
  [class]="'ml-1 ' + (iconOnly ? 'p-button-icon-only' : '')"
  [disabled]="disabled">
  <i class="p-button-icon p-button-icon-left fa fa-solid fa-filter" pBadge [badgeDisabled]="!iconOnly || filterPayload.filters.length === 0" [value]="filterPayload.filters.length === 0 ? '' : filterPayload.filters.length.toString()" badgeStyleClass="p-badge-warning"></i>
  @if (!iconOnly) {
    <span i18n="@@configure-filters-filters" class="p-button-label ml-1">Filters</span>
    @if (filterPayload.filters.length) {
      <p-badge
        [value]="filterPayload.filters.length.toString()" class="p-badge-warning"/>
    }
  }
</p-button>

<p-popover #menu [dismissable]="dismissable" (onHide)="onOverlayHide()" appendTo="body"
  [focusOnShow]="true" [style]="{minWidth: '50rem'}" class="configure-filter-overlay">

  @for (filter of filterPayload.filters; track $index; let index = $index) {
    <div class="mb-3">
      <div class="grid fluid">
        <div class="col-12 md:col-3 flex-grow-1">
          <p-select [(ngModel)]="filter.columnKey" [name]="'columnComponent' + index"
            (onChange)="onChangeFilterField(filter)" [required]="true" class="acted-highlight-req form-field mr-3"
            [options]="allColumns" optionLabel="title" optionValue="key" [filter]="true" filterBy="title"
            placeholder="(none)" i18n-placeholder="@@common-none">
          </p-select>
        </div>
        <div class="col-12 md:col-3  flex-grow-1">
          <p-select [disabled]="!filter.columnComponent" [(ngModel)]="filter.matchMode" [name]="'matchMode' + index"
            [required]="true" class="acted-highlight-req form-field mr-3" [options]="filter.filterMatchModes"
            [optionLabel]="filterLabelField" optionValue="value">
          </p-select>
        </div>
        <div class="col-12 md:col-3  flex-grow-1">
          <!-- span placeholder to align trash can icons.. -->
          @if (!filter.columnComponent) {
            <span class="acted-highlight-req form-field mr-3"
            style="display:inline-block"></span>
          }
          @if (filter.columnComponent && [FilterType.TEXT, FilterType.GLOBAL].includes(filter.columnComponent.filterType)) {
            @if (filter.matchMode !== 'exists' && filter.matchMode !== 'notExists') {
              <input pInputText type="text" [(ngModel)]="filter.value" [disabled]="!filter.matchMode" [required]="true"
                class="acted-highlight-req form-field mr-3" />
            } @else {
              <!-- span placeholder to align trash can icons.. -->
              <span class="acted-highlight-req form-field mr-3" style="display:inline-block"></span>
            }
          }
          @if (filter.columnComponent && filter.columnComponent.filterType === FilterType.SELECT && filter.columnComponent.filterOptions.length > 0) {
            <p-select [(ngModel)]="filter.value" [disabled]="!filter.matchMode"
              [optionLabel]="filter.columnComponent.filterLabelField"
              [optionValue]="filter.columnComponent.filterValueField || 'value'"
              [options]="filter.columnComponent.filterOptions" [filter]="true"
              [filterBy]="filter.columnComponent.filterLabelField" i18n-placeholder="@@common-choose"
              placeholder="(choose)" [required]="true" class="acted-highlight-req form-field mr-3">
              <ng-template let-option pTemplate="option">
                <!-- if there is a value for `filterOptionsTemplate`, use that as the template
                for the filter options -->
                <ng-container *ngTemplateOutlet="filter.columnComponent.filterOptionsTemplate || defaultSelectFilterTemplate; context:{ $implicit: option }"></ng-container>
                <!-- otherwise fallback to this -->
                <ng-template let-option pTemplate="item" #defaultSelectFilterTemplate>
                  {{option[filter.columnComponent.filterLabelField]}}
                </ng-template>
              </ng-template>
            </p-select>
          }
          @if (filter.columnComponent && filter.columnComponent.filterType === FilterType.MSELECT && filter.columnComponent.filterOptions.length > 0) {
            <p-multiSelect [(ngModel)]="filter.value" [disabled]="!filter.matchMode"
              [optionLabel]="filter.columnComponent.filterLabelField"
              [optionValue]="filter.columnComponent.filterValueField || 'value'"
              [options]="filter.columnComponent.filterOptions" [filter]="true"
              [filterBy]="filter.columnComponent.filterLabelField" [group]="filter.columnComponent.group"
              scrollHeight="300px" i18n-placeholder="@@common-choose" placeholder="(choose)"
              [required]="true" class="acted-highlight-req form-field mr-3">
              <!-- this is intentionally removed because we don't use the grouped select in Core (yet) -->
              <!-- <ng-template let-group pTemplate="group">
              <div class="flex align-items-center">
                <p-checkbox [value]="group.value" [(ngModel)]="filter.columnComponent.checkedFilterGroups"
                  (click)="multiSelectGroupSelectChanged(filter.columnComponent.checkedFilterGroups, group, filter.value)"
                  class="mr-2">
                </p-checkbox>
                <span>{{ group.label }}</span>
              </div>
            </ng-template> -->
            <ng-template let-option pTemplate="option">
              <!-- if there is a value for `filterOptionsTemplate`, use that as the template
              for the filter options -->
              <ng-container *ngTemplateOutlet="filter.columnComponent.filterOptionsTemplate || defaultMSelectFilterTemplate; context:{ $implicit: option }"></ng-container>
              <!-- otherwise fallback to this -->
              <ng-template let-option pTemplate="item" #defaultMSelectFilterTemplate>
                {{option[filter.columnComponent.filterLabelField]}}
              </ng-template>
            </ng-template>
          </p-multiSelect>
        }
        @if (filter.columnComponent && filter.columnComponent.filterType === FilterType.DATE) {
          @if (filter.matchMode !== 'exists' && filter.matchMode !== 'notExists') {
            <p-date-picker [(ngModel)]="filter.value" [disabled]="!filter.matchMode" appStopClickPropagation
              [required]="true" class="acted-highlight-req form-field mr-3"
              dateFormat="yy-mm-dd" view="date" dataType="string">
            </p-date-picker>
          } @else {
            <!-- span placeholder to align trash can icons.. -->
            <span class="acted-highlight-req form-field mr-3" style="display:inline-block"></span>
          }
        }
        @if (filter.columnComponent && filter.columnComponent.filterType === FilterType.MONTH) {
          @if (filter.matchMode !== 'exists' && filter.matchMode !== 'notExists') {
            <p-date-picker [(ngModel)]="filter.value" [disabled]="!filter.matchMode"
              [required]="true" class="acted-highlight-req form-field mr-3"
              dateFormat="yy-mm" view="month" dataType="string">
            </p-date-picker>
          } @else {
            <!-- span placeholder to align trash can icons.. -->
            <span class="acted-highlight-req form-field mr-3" style="display:inline-block"></span>
          }
        }
        @if (filter.columnComponent && filter.columnComponent.filterType === FilterType.NUMERIC) {
          @if (filter.matchMode !== 'exists' && filter.matchMode !== 'notExists') {
            <p-inputNumber [(ngModel)]="filter.value" [disabled]="!filter.matchMode" [required]="true" [locale]="locale"
              class="acted-highlight-req form-field mr-3">
            </p-inputNumber>
          } @else {
            <!-- span placeholder to align trash can icons.. -->
            <span class="acted-highlight-req form-field mr-3" style="display:inline-block"></span>
          }
        }
      </div>
      <div class="col-12 md:col-1">
        <p-button icon="fa fa-regular fa-trash-can" label="" (onClick)="deleteFilter(index); $event.stopImmediatePropagation()" [text]="true" severity="danger">
        </p-button>
      </div>
    </div>
  </div>
}

<div class="align-items-center" style="display: flex; justify-content: space-between">
  <div class="p-toolbar-group-left">
    <p-button icon="fa fa-solid fa-plus" i18n-label="@@configure-filters-add-filter" label="Add filter" (onClick)="addFilter()"
      severity="secondary">
    </p-button>
    <p-button icon="fa fa-solid fa-check" i18n-label="@@configure-filters-apply-filter" label="Apply"
      (onClick)="applyFilters()" class="ml-1">
    </p-button>
  </div>
  <div class="p-toolbar-group-right">
    <p-button icon="fa fa-solid fa-filter-circle-xmark" i18n-label="@@configure-filters-clear-filter" label="Clear"
      (onClick)="clearFilters()" severity="secondary" class="ml-1">
    </p-button>
    <p-button icon="fa fa-solid fa-xmark" i18n-label="@@common-close" label="Close"
      (onClick)="menu.hide()" severity="secondary" class="ml-1">
    </p-button>
  </div>
</div>

</p-popover>
